import {Button, DialogContent, Stack, Typography, useTheme} from '@mui/material';
import {IconIllustration, Modal} from 'presentation/components';
import Icon from 'presentation/icons';
import {translations} from 'presentation/translations-new';
import React, {useState} from 'react';
import {AutoSolEnum} from 'main/analytics/gaTagsEnum';
import {useNavigate} from 'react-router-dom';
import {AuthorizationsEnum} from 'presentation/constants';
import {HandleMessage} from 'presentation/components/HandleMessage';
import {useHostName} from 'presentation/hooks';
import {DialogFinishedProps} from './types';
import {ReturnPeriodMessage} from './ReturnPeriodMessage';
import {NextStepsContainer, NextStepsList, StyledTypography} from './styles';

const {title, attentionTitle, successTitle, nextSteps, description, protocol, buttonFinish} =
	translations['pt-br'].privateFlow.requestAuthorizations.modalFinish;
const {successRequest, successRequestAttachment} =
	translations['pt-br'].privateFlow.requestAuthorizations.confirmation;

export function DialogFinished({nuProtocolo, isAttachment, onClose}: DialogFinishedProps) {
	const [openState, setOpenState] = useState(true);
	const theme = useTheme();
	const navigate = useNavigate();
	const {isHAP, isNotredameSaude} = useHostName();
	const showUpdatedCompletion = (isHAP || isNotredameSaude) && !isAttachment;

	const handleCloseModal = () => {
		if (onClose) {
			onClose();
		}
		setOpenState(false);
		navigate(AuthorizationsEnum.AUTHORIZATIONS_REQUESTS, {replace: true});
	};

	return (
		<Modal.Root
			open={openState}
			fullScreen={false}
			data-tag-id={AutoSolEnum.AS_CLICK_OVERLAY_CONCLUSAO}>
			<Modal.Header
				title={showUpdatedCompletion ? attentionTitle : title}
				disableClose={!showUpdatedCompletion}
				onClose={handleCloseModal}
				sx={{height: '64px', justifyContent: 'center'}}
				modalDataTagId={AutoSolEnum.VISUALIZOU_MODAL_DE_CONCLUSAO_AUTOSOL}
			/>
			<DialogContent
				sx={{p: 'initial'}}
				data-tag-id={AutoSolEnum.AS_VISUALIZOU_MODAL_CONCLUSAO}>
				<Stack alignItems="center" gap={2} padding={3}>
					<IconIllustration variant={'success'} />

					<Typography variant="h6" textAlign="center">
						{showUpdatedCompletion
							? successTitle
							: isAttachment
								? successRequestAttachment
								: successRequest}
					</Typography>

					{showUpdatedCompletion ? (
						<NextStepsContainer>
							<Typography variant="subtitle2">{nextSteps.title}</Typography>
							<NextStepsList>
								<Typography component="li" variant="body2">
									{nextSteps.item1}
								</Typography>
								<Typography component="li" variant="body2">
									{nextSteps.item2}
								</Typography>
								<Typography component="li" variant="body2">
									{nextSteps.item3}
								</Typography>
							</NextStepsList>
						</NextStepsContainer>
					) : (
						<StyledTypography variant="body1" textAlign="center">
							{description.line1}
							<br />
							<HandleMessage message={description.line2} />
						</StyledTypography>
					)}

					<ReturnPeriodMessage useAnalysisTitle={showUpdatedCompletion} />

					{nuProtocolo ? (
						<Stack flexDirection={'row'} gap={1} my={1}>
							<Icon
								name="assignment-filled"
								color={theme.colors.brand.primary.blue}
								size={20}
							/>
							<Stack>
								<Typography variant="body1" color={'text.secondary'}>
									{protocol}
								</Typography>
								<Typography variant="body1">{nuProtocolo}</Typography>
							</Stack>
						</Stack>
					) : null}
				</Stack>
			</DialogContent>

			<Modal.Footer>
				<Button
					onClick={handleCloseModal}
					data-tag-id={AutoSolEnum.CLICK_VOLTAR_PARA_CONCLUSAO_AUTOSOL}
					variant="contained"
					size="large"
					fullWidth>
					{buttonFinish}
				</Button>
			</Modal.Footer>
		</Modal.Root>
	);
}
